import request from '../request'

export const userApi = {
  // 获取用户列表
  getUserList (params) {
    return request.get('user/list', { params })
  },

  // 创建用户
  createUser (data) {
    return request.post('user/create', data)
  },

  // 更新用户
  updateUser (id, data) {
    return request.put(`user/update/${id}`, data)
  },

  // 删除用户
  deleteUser (id) {
    return request.delete(`user/delete/${id}`)
  },

  // 重置密码
  resetPassword (id) {
    return request.post(`user/resetPassword/${id}`)
  },

  // 获取用户权限
  getUserPermissions () {
    return request.get('user/permissions')
  },

  // 用户登出
  logout () {
    return request.post('user/logout')
  },

  // 获取所有用户
  getAllUsers () {
    return request.post('user/getAllUsers')
  },

  // 更新密码
  updatePassword (data) {
    return request.post('user/updatePassword', data)
  },

  // 获取所有属性
  getAllProperties () {
    return request.get('property/get')
  },

  // 添加属性
  addProperty (data) {
    return request.post('property/addProperty', data)
  },

  // 更新属性
  updateProperty (data) {
    return request.post('property/updateProperty', data)
  },

  // 删除属性
  deleteProperty (id) {
    return request.get('property/deleteById', { params: { id } })
  },

  // 更新文件类型
  updateFileType (data) {
    return request.post('fileType/updateType', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/user.js